import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

export const CtaBanner = () => (
  <section data-testid="cta-banner-section" className="py-16 sm:py-24 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-slate-900 px-6 py-16 text-center sm:px-12 sm:py-24">
          <div className="absolute -top-24 left-1/2 h-[360px] w-[560px] -translate-x-1/2 rounded-full bg-emerald-500/20 blur-[110px]" aria-hidden="true" />
          <div className="relative">
            <h2 className="mx-auto max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
              ¿Tienes visto un piso? Analízalo gratis en 2 minutos.
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base text-slate-400 sm:text-lg">
              Analiza tu próxima inversión antes de firmar nada. Sin registro, sin tarjeta, sin letra pequeña.
            </p>
            <button
              data-testid="cta-banner-btn"
              onClick={() => scrollToId("#analisis")}
              className="group mt-9 inline-flex items-center gap-2 rounded-full bg-emerald-500 px-9 py-4 text-sm font-semibold text-white shadow-xl shadow-emerald-500/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-emerald-400 hover:shadow-2xl hover:shadow-emerald-500/40"
            >
              Empezar análisis gratis
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
